import React from "react";
import { Radio } from "antd";

const CustomRadioGroup = ({ options, value, onChange, fontSize }) => {
  return (
    <Radio.Group
      value={value}
      onChange={onChange}
      style={{ display: "flex", flexDirection: "column", gap: "10px" }}
    >
      {options.map((option) => (
        <div key={option.value}>
          <Radio
            value={option.value}
            style={{
              fontSize: fontSize || "14px",
              fontWeight: "400",
              color: "#000",
            }}
            className="custom-radio"
          >
            {option.label}
          </Radio>
          {option.description && (
            <div
              style={{
                color: "rgb(75, 75, 75)",
                fontSize: "12px",
                paddingLeft: "24px",
              }}
            >
              {option.description}
            </div>
          )}
        </div>
      ))}
    </Radio.Group>
  );
};

export default CustomRadioGroup;
